import reducerRate from './reducerRate';
export * from './RateAction';
export default reducerRate;